import React from "react";
import PropTypes from "prop-types";
import {
	Box,
	Grid,
	Page,
	Text
} from "@shopify/polaris";

import LappaLogo from "img/logos/lappa-logo.svg";
import parrotIMG from "img/illustrations/mascots/authParrot.svg";

import "./index.scss";

const AuthContainer = (props) => {
	const {
		content = null,
		title = "",
		description = "",
		actions = null,
		secondaryContent = null,
		onParrotClick = null,
	} = props;

	return (
			<div className='loginWrap'>
				<Page >
					<div
							className='LoginTopBlockWrapper'
							style={{marginBottom: 82}}
					>
						<img
								src={LappaLogo}
								width='105px'
								alt="LAPPA"
						/>
					</div >
					<Grid >
						<Grid.Cell
								columnSpan={{
									xs: 6,
									sm: 3,
									md: 3,
									lg: 6,
									xl: 6
								}}
						>
							<div className='loginFormColumn'>
								<Box
										style={{
											display: "flex",
											flexDirection: "column"
										}}
								>
									{title && (
											<Text
													as='h1'
													variant='heading3xl'
													fontWeight='bold'
											>
												{title}
											</Text >
									)}
									{description && <Text color='subdued'>{description}</Text >}
								</Box >
								<br />
								{content}
								{actions && (
										<>
											<br />
											{actions}
										</>
								)}
							</div >
						</Grid.Cell >
						<Grid.Cell
								columnSpan={{
									xs: 6,
									sm: 3,
									md: 3,
									lg: 6,
									xl: 6
								}}
						>
							<div className='authSecondaryContent'>
								{secondaryContent}
							</div>
							{onParrotClick ? (
									<div
											className='parrotImg parrotImg--clickable'
											style={{display: 'inline-block'}}
									>
										<img
												src={parrotIMG}
												alt='parrot'
												draggable={false}
												style={{display: 'block'}}
										/>
										<button
												type='button'
												onClick={onParrotClick}
												aria-label='Go to Manager Page'
												style={{
													position: 'absolute',
													right: 0,
													top: 0,
													bottom: 0,
													width: '35%',
													background: 'none',
													border: 'none',
													padding: 0,
													cursor: 'pointer',
													zIndex: 1,
												}}
										/>
									</div >
							) : (
									<img
											src={parrotIMG}
											alt='parrot'
											className='parrotImg'
									/>
							)}
						</Grid.Cell >
					</Grid >
				</Page >
			</div >
	);
};

AuthContainer.propTypes = {
	content: PropTypes.node,
	title: PropTypes.string,
	description: PropTypes.string,
	actions: PropTypes.node,
	secondaryContent: PropTypes.node,
	onParrotClick: PropTypes.func,
};

export default AuthContainer;
